<template>
  <!-- 管理员仪表盘 -->
  <div class="dashboard">
    <!-- 上半部分：展会统计 + 人气展商 TOP3 -->
    <div class="dashboard__row">
      <!-- 展会最新信息统计 -->
      <div class="dashboard__card dashboard__card--wide">
        <div class="card-header">
          <div class="card-header__title">展会最新信息</div>
        </div>
        <div class="card-stats">
          <div class="stat-item stat-item--highlight">
            <div class="stat-item__number">{{ userData.user_count }}</div>
            <div class="stat-item__label">参展展商人数</div>
          </div>
          <div class="stat-items-group">
            <el-row>
              <el-col :span="6">
                <div class="stat-item__number">{{ userData.visit_count }}</div>
                <div class="stat-item__label">预登记数</div>
              </el-col>
              <el-col :span="6">
                <div class="stat-item__number">{{ userData.view_count }}</div>
                <div class="stat-item__label">浏览数</div>
              </el-col>
              <el-col :span="6">
                <div class="stat-item__number">{{ userData.share_conut }}</div>
                <div class="stat-item__label">转发数</div>
              </el-col>
              <el-col :span="6">
                <div class="stat-item__number">{{ userData.praise_count }}</div>
                <div class="stat-item__label">点赞数</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 人气展商 TOP3 -->
      <div class="dashboard__card">
        <div class="card-header">
          <div class="card-header__title">人气展商TOP3</div>
          <div class="card-header__more" @click="goCompanyList">查看更多 ></div>
        </div>
        <div v-for="(item, index) in userList" :key="item.id" class="rank-item" @click="toExhibitorDetail(item.id)">
          <el-row>
            <el-col :span="4">
              <div class="rank-item__index">{{ index + 1 }}</div>
            </el-col>
            <el-col :span="4">
              <el-image v-if="item.logo !== ''" :src="logoImg + item.logo" class="rank-item__logo" fit="contain"></el-image>
              <div v-else>
                <i class="el-icon-picture-outline" style="font-size: 50px"></i>
              </div>
            </el-col>
            <el-col :span="16">
              <div class="rank-item__info">
                <div class="rank-item__name">{{ item.name }}</div>
                <div class="rank-item__meta">
                  <span>展位号：{{ item.booth }}</span>
                  <span>浏览数：{{ item.view }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 下半部分：展品统计 + 人气展品 TOP3 -->
    <div class="dashboard__row">
      <!-- 参展展品信息统计 -->
      <div class="dashboard__card dashboard__card--wide">
        <div class="card-header">
          <div class="card-header__title">参展展品信息</div>
          <div class="card-header__more" @click="goProductList">查看更多 ></div>
        </div>
        <div class="card-stats">
          <div class="stat-item stat-item--highlight">
            <div class="stat-item__number">{{ productData.product_count }}</div>
            <div class="stat-item__label">参展展品数量</div>
          </div>
          <div class="stat-items-group">
            <el-row>
              <el-col :span="8">
                <div class="stat-item__number">{{ productData.product_view_count }}</div>
                <div class="stat-item__label">浏览数</div>
              </el-col>
              <el-col :span="8">
                <div class="stat-item__number">{{ productData.product_share_count }}</div>
                <div class="stat-item__label">转发数</div>
              </el-col>
              <el-col :span="8">
                <div class="stat-item__number">{{ productData.product_praise_count }}</div>
                <div class="stat-item__label">点赞数</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 人气展品 TOP3 -->
      <div class="dashboard__card">
        <div class="card-header">
          <div class="card-header__title">人气展品TOP3</div>
          <div class="card-header__more" @click="goProductList">查看更多 ></div>
        </div>
        <div v-for="item in productList" :key="item.id" class="rank-item" @click="toProductDetail(item.id)">
          <el-row>
            <el-col :span="6">
              <el-image :src="productImg + item.img" class="rank-item__product-img"></el-image>
            </el-col>
            <el-col :span="18">
              <div class="rank-item__info">
                <div class="rank-item__name">{{ item.title }}</div>
                <div class="rank-item__meta">
                  <span class="rank-item__type">分类：{{ item.type }}</span>
                  <span>浏览数：{{ item.view }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "adminIndex",
  data() {
    return {
      /** 人气展商列表 */
      userList: [],
      /** 人气展品列表 */
      productList: [],
      /** 展商统计数据 */
      userData: [],
      /** 展品统计数据 */
      productData: [],
      /** 展品图片 OSS 前缀 */
      productImg: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/product/",
      /** 展商 Logo OSS 前缀 */
      logoImg: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/logo/",
    };
  },
  mounted() {
    this.getTopExhibitors();
    this.getTopProducts();
    this.getIndexData();
  },
  methods: {
    /**
     * 获取人气展商 TOP3
     * 按点赞数降序取前 3 条
     */
    getTopExhibitors() {
      let url = this.baseUrl + "/admin/users/?ordering=-praise&size=3";
      api.fetchData(url).then((res) => {
        this.userList = res.results;
      });
    },

    /**
     * 获取人气展品 TOP3
     * 按点赞数降序取前 3 条
     */
    getTopProducts() {
      let url = this.baseUrl + "/admin/products/?ordering=-praise&size=3";
      api.fetchData(url).then((res) => {
        this.productList = res.results;
      });
    },

    /**
     * 获取首页统计数据
     * 包含展商和展品的浏览、转发、点赞等数据
     */
    getIndexData() {
      let url = this.baseUrl + "/admin/indexinfo/";
      api.fetchData(url).then((res) => {
        this.userData = res.user;
        this.productData = res.product;
      });
    },

    /** 跳转到展商列表页 */
    goCompanyList() {
      this.$router.push({ name: "admin_companyList" });
    },

    /** 跳转到展品列表页 */
    goProductList() {
      this.$router.push({ name: "admin_productList" });
    },

    /**
     * 跳转到展商详情页
     * @param {number} id - 展商 ID
     */
    toExhibitorDetail(id) {
      this.$router.push({ name: "admin_exhibitorDetails", query: { id: id } });
    },

    /**
     * 跳转到展品详情页
     * @param {number} id - 展品 ID
     */
    toProductDetail(id) {
      this.$router.push({ name: "admin_productDetail", query: { id: id } });
    },
  },
};
</script>

<style scoped>
/* 仪表盘容器 */
.dashboard {
  padding: var(--spacing-lg, 24px);
  min-width: 800px;
}

/* 每行卡片容器 */
.dashboard__row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-lg, 24px);
  margin-bottom: var(--spacing-lg, 24px);
}

/* 卡片基础样式 */
.dashboard__card {
  flex: 1 1 300px;
  min-width: 300px;
  background: var(--card-bg, #ffffff);
  border-radius: var(--radius-lg, 8px);
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.05));
  overflow: hidden;
}

/* 宽卡片（统计数据） */
.dashboard__card--wide {
  flex: 2 1 400px;
  min-width: 400px;
}

/* 卡片标题栏 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  line-height: 56px;
  padding: 0 var(--spacing-lg, 24px);
  border-bottom: 1px solid var(--border-color, #e2e8f0);
}

.card-header__title {
  font-weight: 600;
  font-size: 15px;
  color: var(--text-primary, #1e293b);
}

.card-header__more {
  font-size: 14px;
  color: var(--color-primary, #1a73e8);
  cursor: pointer;
}

/* 统计数据区域 */
.card-stats {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: var(--spacing-lg, 24px);
}

/* 高亮统计项（大数字） */
.stat-item--highlight {
  text-align: center;
  padding-right: var(--spacing-lg, 24px);
  border-right: 1px dashed var(--border-color, #e2e8f0);
  min-width: 120px;
  flex-shrink: 0;
}

.stat-items-group {
  flex: 1;
  min-width: 200px;
  padding-left: var(--spacing-lg, 24px);
  text-align: center;
}

.stat-item__number {
  font-size: 36px;
  font-weight: 700;
  color: var(--color-primary, #1a73e8);
  line-height: 1.2;
}

.stat-item__label {
  font-size: 14px;
  color: var(--text-secondary, #64748b);
  margin-top: var(--spacing-sm, 8px);
}

/* 排行榜条目 */
.rank-item {
  padding: var(--spacing-md, 16px);
  border-bottom: 1px solid var(--border-color, #e2e8f0);
  cursor: pointer;
}

.rank-item:last-child {
  border-bottom: none;
}

.rank-item__index {
  font-size: 28px;
  font-weight: 700;
  line-height: 50px;
  color: var(--text-primary, #1e293b);
}

.rank-item__logo {
  height: 50px;
  width: 50px;
}

.rank-item__product-img {
  width: 50px;
  height: 50px;
}

.rank-item__info {
  margin-left: 10px;
}

.rank-item__name {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-primary, #1e293b);
}

.rank-item__meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 40px;
  color: var(--text-secondary, #64748b);
}

.rank-item__type {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

/* 窄屏适配 */
@media screen and (max-width: 1200px) {
  .stat-item__number {
    font-size: 28px;
  }
  .stat-item--highlight {
    padding-right: var(--spacing-md, 16px);
    border-right: none;
  }
  .stat-items-group {
    padding-left: 0;
  }
  .card-stats {
    gap: var(--spacing-md, 16px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/index.vue